// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__1WnG4","requiredAsterisk":"Info_requiredAsterisk__bv6rv"};